import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Hero } from '../components/Hero';
import { ClientLogos } from '../components/ClientLogos';
import { About } from '../components/About';
import { Specialties } from '../components/Specialties';
import { WhyForax } from '../components/WhyForax';
import { ProjectsGallery } from '../components/ProjectsGallery';
import { FinalCTA } from '../components/FinalCTA';
export function LandingPage() {
  return <main className="min-h-screen w-full bg-white font-sans text-gray-900 selection:bg-blue-600 selection:text-white" data-id="element-703">
      <Header data-id="element-704" />

      <div id="home" data-id="element-705">
        <Hero data-id="element-706" />
      </div>

      <ClientLogos data-id="element-707" />

      <div id="about" data-id="element-708">
        <About data-id="element-709" />
      </div>

      <Specialties data-id="element-710" />
      <WhyForax data-id="element-711" />

      <div id="projects" data-id="element-712">
        <ProjectsGallery data-id="element-713" />
      </div>

      <div id="contact" data-id="element-714">
        <FinalCTA data-id="element-715" />
      </div>

      <Footer data-id="element-716" />
    </main>;
}